import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Util } from 'src/app/util';
import { LocaleService } from '../../services/locale.service';
import { ResourceFormat } from 'src/app/models/resource-format';

@Component({
  selector: 'app-resource-type-selector',
  templateUrl: './resource-type-selector.component.html',
  styleUrls: ['./resource-type-selector.component.scss'],
})
export class ResourceTypeSelectorComponent implements OnInit {
  resourceFormats: ResourceFormat[] = [
    { label: 'all', format: 'ALL', selected: true },
    { label: 'eBook', format: 'EBOOK', selected: false },
    { label: 'Audio', format: 'AUDIO', selected: false },
    { label: 'Video', format: 'VIDEO', selected: false },
    { label: 'Scorm', format: 'SCORM', selected: false },
  ];

  @Output() resourceFormatSelected = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  changeSelectedFormat(format: string) {
    this.resourceFormatSelected.emit(format);
    const previous = this.resourceFormats.find((r) => r.selected);
    const current = this.resourceFormats.find((r) => r.format === format);
    previous.selected = false;
    current.selected = true;
  }

  getFormatIcon(format: string) {
    return Util.resolveIcon(format);
  }
}
